import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent{
  user=true;
  constructor(public afAuth: AngularFireAuth) {
    
    this.afAuth.authState.subscribe(user=>{
      console.log(user);
      if(user == null){
        this.user = false;
      }
      else{
        this.user = true;
      }
      
    })
  }

  login(email,password){
    this.afAuth.auth.signInWithEmailAndPassword(email,password);
  }

}



// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/app/app.component.ts